module.exports = __webpack_public_path__ + "img/sp-step2.920128ca.png";